import { Component, Vue } from 'vue-property-decorator';
import { environment } from '@/helpers/Environment';
import Loader from '@/components/Loader.vue';
import TixMessage from '@/components/elements/TixMessage.vue';
import CartAlreadyBookedError from '@/errors/CartAlreadyBookedError';
import NotFoundError from '@/errors/NotFoundError';
import { logInTrackJS } from '@/errors/helpers';
import { isLoggedIn } from '@/state/Authentication';
import store from '@/store/store';
@Component({ name: 'TransferCartRoute', components: { Loader, TixMessage } })
export default class TransferCartRoute extends Vue {
    error = null;
    beforeRouteEnter(to, from, next) {
        // Carts assigned to the logged in user are only readable with GET my/cart/:id, which 404s for carts
        // belonging to anyone else. Unlike injectCart() in <CheckoutRoute>, the fallback to the public
        // GET cart/:id does not log the user out.
        const cartId = to.params.cartId;
        const injecting = isLoggedIn()
            ? store.dispatch('Cart/injectOwnCart', cartId).catch((error) => {
                if (error.response)
                    return store.dispatch('Cart/inject', cartId);
                throw error;
            })
            : store.dispatch('Cart/inject', cartId);
        injecting
            .then(() => {
            if (store.getters['Cart/cart'].ownedByPublicIdentity || store.getters['Cart/ownedByAuthenticatedUser']) {
                next({
                    path: to.query.next ?? '/checkout',
                    query: to.query,
                    hash: to.hash,
                });
            }
            else {
                // Loaded successfully, but it belongs to another member so it is not modifiable.
                logInTrackJS('TransferCartRoute: Cart not owned by public identity', {
                    cartId: to.params.cartId,
                    cartIdentityId: store.getters['Cart/cart'].identity_id,
                    publicIdentityId: environment.portal.public_identity_id,
                });
                store.dispatch('Cart/clearAll');
                next((vm) => (vm.error = 'This cart belongs to another member'));
            }
        })
            .catch((error) => {
            if (error.response?.status === 403) {
                logInTrackJS('TransferCartRoute: 403 Access denied to cart', error);
                next((vm) => (vm.error = '403 Access denied to cart'));
            }
            else if (error instanceof NotFoundError || error.response?.status === 404) {
                logInTrackJS('TransferCartRoute: 404 Cart not found', error);
                next((vm) => (vm.error = '404 Cart not found'));
            }
            else if (error instanceof CartAlreadyBookedError) {
                next(`/checkout/complete?orderIds=${error.orderId}`);
            }
            else {
                throw error;
            }
        });
    }
}
